import SMSList from "./pages/ListPage.vue";
import SMSIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/sms",
    component: SMSIndex,
    redirect: "/sms/list",
    name: "sms",
    children: [
      {
        path: "list",
        component: SMSList,
        name: "sms.list",
        // The ff. code is taken from https://git.o.ocom.com.au/django/mcharrys_portal/issues/230#issuecomment-39327
        beforeEnter(to, from, next) {
          window.open("/ui/sms/list?order=desc&sort=created_date", "_blank");
          return false; // don't
        },
      },
    ],
  },
];
